module.exports = __webpack_public_path__ + "img/spotify-logo-green.7a34cf42.png";